import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button, Card, CardBody, Col, Collapse, Input, Row } from "reactstrap"
import ConsumptionTimeLine from "./CouponDetailsComponents/ConsumptionTimeLine"
import classNames from "classnames"
import ConsumptionAnalytic from "./CouponDetailsComponents/ConsumptionAnalytic"
import { useTranslation } from "react-i18next"

const couponDetailsData = {
  id: "ID-145871",
  name: "Coupons Name",
  count: 10,
  price: "QAR 100",
  productSize: "Bottle 500ml",
  refillTimes: "3 Days/Week",
  refillSchedule: [
    { day: "sat", enabled: true, time: "earlyMorning" },
    { day: "sun", enabled: false, time: "notSelected" },
    { day: "mon", enabled: true, time: "afternoon" },
    { day: "tue", enabled: false, time: "notSelected" },
    { day: "wed", enabled: true, time: "night" },
    { day: "thu", enabled: false, time: "notSelected" },
    { day: "fri", enabled: false, time: "notSelected" },
  ],
  itemPerRefill: "1 Gallon/Once",
  status: "Active",
  createdAt: "2025-08-27",
  consumptionTimeLine: [
    {
      couponState: "Coupon Used",
      date: "23 dec, 2023 at 10:00 aM.",
      details: "A coupon pack for 10 refills was purchased and activated",
      location: "Home",
    },
    {
      couponState: "Coupon Used",
      date: "23 dec, 2023 at 10:00 aM.",
      details: "A coupon pack for 10 refills was purchased and activated",
      location: "Home",
    },
    {
      couponState: "Coupon Used",
      date: "23 dec, 2024 at 10:00 aM.",
      details: "2 bottles of 500ml water delivered. 3coupons remaining",
      location: "Work",
    },
    {
      couponState: "Coupon Used",
      date: "23 dec, 2024 at 10:00 aM.",
      details: "2 bottles of 500ml water delivered. 5 coupons remaining",
      location: "Work",
    },
    {
      couponState: "Coupon Activated",
      date: "23 dec, 2024 at 10:00 aM.",
      details: "A coupon pack for 10 refills was purchased and activated",
      location: "Home",
    },
  ],
  consumptionAnalytics: {
    total: 25,
    used: 10,
    remaining: 15,
    avgConsumption: "5 coupon / week",
    nextRedirectRefill: "23 dec, 2024",
    estCompletionDate: "23 dec, 2024",
    consmptionHabit:
      "Consumption is consistent, primarily on Friday. suggests a stable weekly routine",
    consumptionAddress: [
      {
        type: "Home",
        address: "123 Main St, Anytown, USA",
        default: true,
        count: 3,
      },
      {
        type: "Work",
        address: "456 Elm St, Anytown, USA",
        default: false,
        count: 2,
      },
    ],
  },
}

const CouponDetails = () => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)
  const [openFirstAccordion, setOpenFirstAccordion] = useState("1")

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    })
  }
  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("coupons_coupons")}
          subBreadcrumbItem={couponDetailsData.name}
        />
        <div className="d-flex gap-2">
          <Button
            onClick={() => {}}
            className="bg-gradiant-blue border-0 text-capitalize"
          >
            {t("coupons_editCoupon")}
          </Button>
          <Button
            onClick={() => {}}
            className="bg-transparent border text-danger border-danger text-capitalize"
          >
            {t("coupons_deleteCoupon")}
          </Button>
        </div>
      </div>
      <Card className="text-center shadow-md rounded-3">
        <CardBody className="p-3">
          <div className="d-flex mb-2 align-items-start justify-content-between">
            <div className="d-flex flex-column align-items-start gap-1">
              <h4 className="fw-bold medium text-capitalize mb-0">
                {t("coupons_couponSerial")}
              </h4>
              <span className="text-muted">
                {t("common_createdAt")}: {couponDetailsData.createdAt}
              </span>
            </div>
          </div>

          <Row>
            <Col
              md={2}
              className="col-form-label text-start flex align-items-center fw-semibold "
            >
              {t("coupons_couponId")}
            </Col>
            <Col
              md={10}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="text-muted  m-0">{couponDetailsData.id}</p>
              <button
                className="relative cursor-pointer border-0 bg-transparent"
                onClick={() => {
                  copyToClipboard(couponDetailsData.id)
                }}
              >
                <i className="bx bx-copy px-2 text-primary bx-sm cursor-pointer"></i>
                {copied && (
                  <span
                    className="position-absolute  translate-middle-x mt-1 text-success small"
                    style={{ top: "14px", marginLeft: "20px" }}
                  >
                    {t("common_copied")}
                  </span>
                )}
              </button>
            </Col>
          </Row>
          <Row>
            <Col
              md={2}
              className="col-form-label text-start flex align-items-center fw-semibold "
            >
              {t("coupons_price")}
            </Col>
            <Col
              md={10}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="text-muted fw-semibold m-0">
               QAR {couponDetailsData.price}
              </p>
            </Col>
          </Row>
          <Row>
            <Col
              md={2}
              className="col-form-label text-start flex align-items-center fw-semibold"
            >
              {t("coupons_count")}
            </Col>
            <Col
              md={10}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="text-muted m-0">
                {couponDetailsData.count} {t("coupons_coupons")}
              </p>
            </Col>
          </Row>
          <Row>
            <Col
              md={2}
              className="col-form-label text-start flex align-items-center fw-semibold"
            >
              {t("coupons_productSize")}
            </Col>
            <Col
              md={10}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="text-muted m-0">{couponDetailsData.productSize}</p>
            </Col>
          </Row>
          <Row>
            <Col
              md={2}
              className="col-form-label text-start flex align-items-center fw-semibold"
            >
              {t("coupons_refillTimesPerWeek")}
            </Col>
            <Col
              md={10}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="text-muted m-0">{couponDetailsData.refillTimes}</p>
            </Col>
          </Row>
          {/* Refill Schedule Days */}
          <Row className="mt-2">
            <Col md={2}></Col>
            <Col md={10}>
              <div className="d-flex gap-2 flex-wrap">
                {couponDetailsData.refillSchedule.map((schedule) => (
                  <div
                    key={schedule.day}
                    className="border rounded p-2"
                    style={{ minWidth: "80px" }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span className="font-size-12 fw-semibold text-capitalize">
                        {t(`coupons_${schedule.day}`)}
                      </span>
                      <div className="form-check form-switch m-0">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={schedule.enabled}
                          disabled
                          style={{ cursor: "not-allowed" }}
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <i className="mdi mdi-clock-outline font-size-12 text-muted"></i>
                      <span
                        className="font-size-10 text-muted"
                        style={{ opacity: schedule.enabled ? 1 : 0.5 }}
                      >
                        {schedule.enabled && schedule.time !== "notSelected"
                          ? t(`coupons_${schedule.time}`)
                          : t("coupons_notSelected")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              md={2}
              className="col-form-label text-start flex align-items-center fw-semibold"
            >
              {t("coupons_itemsCountPerOnce")}
            </Col>
            <Col
              md={10}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="text-muted m-0">
                {couponDetailsData.itemPerRefill}
              </p>
            </Col>
          </Row>
          <div className="d-flex gap-2 align-items-center mt-2">
            <p className="text-muted text-start">
              <b>{t("coupons_compaignActive")}</b>
              <span> ({t("coupons_inactivePeriod")})</span>
            </p>
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${couponDetailsData.id}`}
                checked={couponDetailsData.status === "Active"}
                onChange={() => {}}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <div className="accordion shadow-md rounded-3" id="accordion">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className={classNames("accordion-button", "fw-medium", {
                collapsed: !openFirstAccordion,
              })}
              type="button"
              onClick={() =>
                setOpenFirstAccordion(openFirstAccordion === "0" ? "1" : "0")
              }
              style={{ cursor: "pointer" }}
            >
              {t("coupons_consumptionHistory")}
            </button>
          </h2>
          <Collapse
            isOpen={openFirstAccordion === "1"}
            className="accordion-collapse"
          >
            <div className="accordion-body">
              <Row>
                <Col lg="7">
                  <ConsumptionTimeLine
                    data={couponDetailsData.consumptionTimeLine}
                  />
                </Col>
                <Col lg="5">
                  <ConsumptionAnalytic
                    data={couponDetailsData.consumptionAnalytics}
                  />
                </Col>
              </Row>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  )
}

export default CouponDetails
